import { Service } from '../types';

export const services: Service[] = [
  {
    id: 1,
    title: 'Executive Search',
    description: 'Our specialized executive search helps you find high-caliber leadership who align with your vision and can drive growth.',
    icon: 'users',
  },
  {
    id: 2,
    title: 'Technical Recruitment',
    description: 'We connect you with top technical talent, from software engineers to product designers, who match your stack and culture.',
    icon: 'code',
  },
  {
    id: 3,
    title: 'Startup Scaling',
    description: 'Tailored recruitment strategies to help your startup grow from seed to series funding with the right team members.',
    icon: 'rocket',
  },
  {
    id: 4,
    title: 'Talent Assessment',
    description: 'Our comprehensive assessment process ensures candidates have both the technical skills and cultural fit for your company.',
    icon: 'clipboard-check',
  },
];